// extracted by mini-css-extract-plugin
module.exports = {"header":"NlSearchModule_header__Xpwwx"};